import { render, staticRenderFns } from "./CoozzyAngleRightIcon.vue?vue&type=template&id=59ffc64b&scoped=true"
import script from "./CoozzyAngleRightIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAngleRightIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAngleRightIcon.vue?vue&type=style&index=0&id=59ffc64b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffc64b",
  null
  
)

export default component.exports